(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-blocks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tcc-engraving')) {
    class TccEngraving extends HTMLElement {
      constructor() {
        super();
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
      }

      connectedCallback() {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        if (this._ready) return;
        this._ready = true;

        this.dialog = this.querySelector('dialog');
        this.submitBtn = this.querySelector('[data-engr-submit]');
        this.formError = this.querySelector('[data-engr-form-error]');
        this.variants = this.readJSON('[data-engr-variants]', {});
        this.moneyFormat = this.readJSON('[data-engr-money]', '${{amount}}');

        this.querySelector('[data-engr-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-engr-close]').addEventListener('click', () => this.close());
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
        this.querySelectorAll('[data-engr-input]').forEach((input) =>
          input.addEventListener('input', () => this.onInput(input))
        );
        this.querySelectorAll('[data-engr-toggle]').forEach((toggle) =>
          toggle.addEventListener('change', () => this.onToggle(toggle))
        );
        this.submitBtn.addEventListener('click', () => this.submit());
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      readJSON(selector, fallback) {
        try { return JSON.parse(this.querySelector(selector).textContent); } catch (e) { return fallback; }
      }

      onBlockSelect(e) { if (e.detail && e.detail.blockId === this.dataset.blockId) this.open(); }
      onBlockDeselect(e) { if (e.detail && e.detail.blockId === this.dataset.blockId) this.close(); }

      /* Main product form: nearest cart form above this block (works in PDP + quick view) */
      getMainIdInput() {
        let el = this.parentElement;
        while (el) {
          const input = el.querySelector('form[action*="/cart/add"] [name="id"]');
          if (input) return input;
          el = el.parentElement;
        }
        return null;
      }

      getVariantId() {
        const input = this.getMainIdInput();
        return (input && input.value) || this.dataset.variantId;
      }

      getMainFormProperties() {
        const input = this.getMainIdInput();
        const form = input && (input.form || input.closest('form'));
        const props = {};
        let sellingPlan = null;
        if (!form) return { props, sellingPlan };
        new FormData(form).forEach((value, key) => {
          if (typeof value !== 'string' || value === '') return;
          if (key.startsWith('properties[')) props[key.slice(11, -1)] = value;
          if (key === 'selling_plan') sellingPlan = value;
        });
        return { props, sellingPlan };
      }

      open() {
        if (!this.isConnected || this.dialog.open) return;
        this.setFormError('');
        this.updateTotals();
        this.dialog.showModal();
      }

      close() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      sanitize(value) {
        switch (this.dataset.filter) {
          case 'alnum': return value.replace(/[^A-Za-z0-9]/g, '');
          case 'alnum_space': return value.replace(/[^A-Za-z0-9 ]/g, '');
          default: return value;
        }
      }

      onInput(input) {
        let value = this.sanitize(input.value);
        if (input.maxLength > 0) value = value.slice(0, input.maxLength);
        if (value !== input.value) input.value = value;
        const option = input.closest('[data-engr-option]');
        const count = option.querySelector('[data-engr-count]');
        if (count) count.textContent = value.length;
        this.setOptionError(option, '');
      }

      onToggle(toggle) {
        const option = toggle.closest('[data-engr-option]');
        const field = option.querySelector('[data-engr-field]');
        field.hidden = !toggle.checked;
        toggle.setAttribute('aria-expanded', String(toggle.checked));
        option.classList.toggle('is-active', toggle.checked);
        this.setOptionError(option, '');
        if (toggle.checked) {
          const input = field.querySelector('[data-engr-input]');
          if (input) input.focus();
        }
        this.updateTotals();
      }

      activeAddons() {
        return [...this.querySelectorAll('[data-engr-option][data-type="addon"]')].filter((o) => {
          const t = o.querySelector('[data-engr-toggle]');
          return t && t.checked;
        });
      }

      updateTotals() {
        const variant = this.variants[this.getVariantId()];
        const base = variant ? variant.price : 0;
        const addons = this.activeAddons().reduce((sum, o) => sum + (parseInt(o.dataset.price, 10) || 0), 0);
        const total = this.formatMoney(base + addons);
        this.querySelector('[data-engr-subtotal]').textContent = total;
        this.querySelector('[data-engr-total]').textContent = total;
        this.submitBtn.disabled = Boolean(variant && !variant.available);
      }

      formatMoney(cents) {
        const format = String(this.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const name = match ? match[1] : 'amount';
        const fmt = (decimals, thousands, decimal) => {
          const [int, frac] = (cents / 100).toFixed(decimals).split('.');
          const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return frac ? grouped + decimal + frac : grouped;
        };
        let value;
        switch (name) {
          case 'amount_no_decimals': value = fmt(0, ',', '.'); break;
          case 'amount_with_comma_separator': value = fmt(2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
          case 'amount_with_apostrophe_separator': value = fmt(2, "'", '.'); break;
          case 'amount_with_space_separator': value = fmt(2, ' ', ','); break;
          default: value = fmt(2, ',', '.');
        }
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      }

      setOptionError(option, message) {
        const error = option.querySelector('[data-engr-error]');
        const input = option.querySelector('[data-engr-input]');
        if (error) { error.textContent = message; error.hidden = !message; }
        if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
      }

      setFormError(message) {
        this.formError.textContent = message;
        this.formError.hidden = !message;
      }

      buildItems() {
        const requiredMsg = this.dataset.errorRequired || 'Please enter your engraving.';
        const title = this.dataset.productTitle;
        let firstInvalid = null;

        const { props: mainProps, sellingPlan } = this.getMainFormProperties();
        const front = this.querySelector('[data-engr-option][data-type="main"]');
        if (front) {
          const input = front.querySelector('[data-engr-input]');
          const value = input.value.trim();
          if (!value && front.dataset.required === 'true') {
            this.setOptionError(front, requiredMsg);
            firstInvalid = firstInvalid || input;
          } else if (value) {
            mainProps[front.dataset.property] = value;
          }
        }

        const mainItem = { id: Number(this.getVariantId()), quantity: 1 };
        if (Object.keys(mainProps).length) mainItem.properties = mainProps;
        if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);
        const items = [mainItem];

        this.activeAddons().forEach((option) => {
          const input = option.querySelector('[data-engr-input]');
          const value = input.value.trim();
          if (!value) {
            this.setOptionError(option, requiredMsg);
            firstInvalid = firstInvalid || input;
            return;
          }
          items.push({
            id: Number(option.dataset.variantId),
            quantity: 1,
            properties: {
              _customization_item: 'true',
              [option.dataset.property]: value,
              'Belongs To': title
            }
          });
        });

        if (firstInvalid) { firstInvalid.focus(); return null; }
        return items;
      }

      async submit() {
        if (this.submitBtn.disabled) return;
        this.setFormError('');
        const items = this.buildItems();
        if (!items) return;

        this.submitBtn.disabled = true;
        this.submitBtn.classList.add('is-loading');
        this.submitBtn.setAttribute('aria-busy', 'true');

        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');

          this.close();
          this.reset();
          document.dispatchEvent(new CustomEvent('tcc:engraving:added', { detail: { items, response: data } }));
          document.dispatchEvent(new Event(this.dataset.cartEvent || 'gOpenCart'));
        } catch (err) {
          this.setFormError(err.message);
        } finally {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.removeAttribute('aria-busy');
          this.updateTotals();
        }
      }

      reset() {
        this.querySelectorAll('[data-engr-option]').forEach((option) => {
          const input = option.querySelector('[data-engr-input]');
          const count = option.querySelector('[data-engr-count]');
          const toggle = option.querySelector('[data-engr-toggle]');
          if (input) input.value = '';
          if (count) count.textContent = '0';
          if (toggle && toggle.checked) { toggle.checked = false; this.onToggle(toggle); }
          this.setOptionError(option, '');
        });
      }
    }
    customElements.define('tcc-engraving', TccEngraving);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tcc-engraving-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tcc-engraving-v2')) {
    /* Built without a literal double brace so Shopify doesn't parse it as Liquid */
    const TCC_ENGR2_MONEY_FALLBACK = '$' + '{'.repeat(2) + 'amount' + '}'.repeat(2);
    /* Preview areas are measured against a 500px-wide reference image */
    const TCC_ENGR2_REF = 500;
    const TCC_ENGR2_FIT_RECT = 0.9;
    const TCC_ENGR2_FIT_CIRCLE = 0.7;
    const TCC_ENGR2_LINE_HEIGHT = 1.15;

    class TccEngravingV2 extends HTMLElement {
      constructor() {
        super();
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
      }

      connectedCallback() {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        if (this._ready) return;
        this._ready = true;

        this.dialog = this.querySelector('dialog');
        this.submitBtn = this.querySelector('[data-engr2-submit]');
        this.formError = this.querySelector('[data-engr2-form-error]');
        this.previewImg = this.querySelector('[data-engr2-preview-img]');
        this.previewName = this.querySelector('[data-engr2-preview-name]');
        this.zone = this.querySelector('[data-engr2-zone]');
        this.zoneText = this.querySelector('[data-engr2-zone-text]');

        this.fonts = this.readJSON('[data-engr2-fonts]', []);
        this.variants = this.readJSON('[data-engr2-variants]', {});
        this.moneyFormat = this.readJSON('[data-engr2-money]', TCC_ENGR2_MONEY_FALLBACK);
        this.separator = this.dataset.separator || ' / ';

        this.locs = [...this.querySelectorAll('[data-engr2-loc]')];
        this.locs.forEach((loc) => this.bindLoc(loc));

        this.querySelector('[data-engr2-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-engr2-close]').addEventListener('click', () => this.close());
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
        this.submitBtn.addEventListener('click', () => this.submit());
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      readJSON(selector, fallback) {
        try { return JSON.parse(this.querySelector(selector).textContent); } catch (e) { return fallback; }
      }

      onBlockSelect(e) { if (e.detail && e.detail.blockId === this.dataset.blockId) this.open(); }
      onBlockDeselect(e) { if (e.detail && e.detail.blockId === this.dataset.blockId) this.close(); }

      /* ---------- Location wiring ---------- */
      bindLoc(loc) {
        this.getLineInputs(loc).forEach((input) =>
          input.addEventListener('input', () => this.onInput(loc, input))
        );

        const toggle = loc.querySelector('[data-engr2-toggle]');
        if (toggle) toggle.addEventListener('change', () => this.onToggle(loc, toggle));

        loc.querySelectorAll('[data-engr2-font]').forEach((radio) =>
          radio.addEventListener('change', () => { this.setCurrent(loc); this.render(loc); })
        );

        loc.addEventListener('focusin', () => { if (this.isOpen(loc)) this.setCurrent(loc); });
      }

      isOpen(loc) {
        const toggle = loc.querySelector('[data-engr2-toggle]');
        return !toggle || toggle.checked;
      }

      getLineInputs(loc) { return [...loc.querySelectorAll('[data-engr2-line]')]; }

      getLines(loc) { return this.getLineInputs(loc).map((i) => i.value.trim()); }

      /* Value saved to the cart: non-empty lines joined with the separator */
      getText(loc) { return this.getLines(loc).filter(Boolean).join(this.separator); }

      getFont(loc) {
        const checked = loc.querySelector('[data-engr2-font]:checked');
        return this.fonts[checked ? Number(checked.value) : 0] || null;
      }

      sanitize(value) {
        switch (this.dataset.filter) {
          case 'alnum': return value.replace(/[^A-Za-z0-9]/g, '');
          case 'alnum_space': return value.replace(/[^A-Za-z0-9 ]/g, '');
          default: return value;
        }
      }

      /* Enforces per-line max (maxlength) and the location's total max, spaces included */
      onInput(loc, input) {
        let value = this.sanitize(input.value);
        if (input.maxLength > 0) value = value.slice(0, input.maxLength);

        const max = Number(loc.dataset.max) || 0;
        if (max) {
          const others = this.getLineInputs(loc)
            .filter((i) => i !== input)
            .reduce((sum, i) => sum + i.value.length, 0);
          value = value.slice(0, Math.max(0, max - others));
        }
        if (value !== input.value) input.value = value;

        this.refreshCounts(loc);
        this.setLocError(loc, '');
        this.setCurrent(loc);
        this.render(loc);
      }

      refreshCounts(loc) {
        let total = 0;
        this.getLineInputs(loc).forEach((input) => {
          total += input.value.length;
          const count = input.parentElement.querySelector('[data-engr2-count]');
          if (count) count.textContent = input.value.length;
        });
        const totalEl = loc.querySelector('[data-engr2-total]');
        if (totalEl) totalEl.textContent = total;

        const sample = this.getLines(loc).filter(Boolean).join(' ');
        loc.classList.toggle('has-text', sample !== '');
        loc.querySelectorAll('[data-engr2-sample]').forEach((s) => {
          s.textContent = sample || s.dataset.fontName;
        });
      }

      onToggle(loc, toggle) {
        const body = loc.querySelector('[data-engr2-body]');
        body.hidden = !toggle.checked;
        toggle.setAttribute('aria-expanded', String(toggle.checked));
        loc.classList.toggle('is-open', toggle.checked);
        this.setLocError(loc, '');

        if (toggle.checked) {
          this.setCurrent(loc);
          const first = this.getLineInputs(loc)[0];
          if (first) first.focus();
        } else if (this.current === loc) {
          this.setCurrent(this.locs.find((l) => this.isOpen(l)) || this.locs[0], true);
        }
        this.updateTotals();
      }

      /* ---------- Preview ---------- */
      setCurrent(loc, force) {
        if (!loc || (this.current === loc && !force)) return;
        this.current = loc;
        this.locs.forEach((l) => l.classList.toggle('is-current', l === loc));

        this.previewName.textContent = loc.dataset.name || '';

        const variant = this.variants[this.getVariantId()];
        const src = loc.dataset.image || (variant && variant.image) || this.dataset.defaultImage;
        if (src && this.previewImg.getAttribute('src') !== src) this.previewImg.setAttribute('src', src);

        const z = this.zone.style;
        z.setProperty('--zx', Number(loc.dataset.x) || 50);
        z.setProperty('--zy', Number(loc.dataset.y) || 50);
        z.setProperty('--zw', Number(loc.dataset.w) || 30);
        z.setProperty('--zh', Number(loc.dataset.h) || 10);
        this.zone.classList.toggle('is-circle', loc.dataset.shape === 'circle');

        this.render(loc);
      }

      /* Font size (in reference px) that fits every line inside the area */
      fitSize(loc, lines, font) {
        if (!lines.length) return 0;
        this.ctx = this.ctx || document.createElement('canvas').getContext('2d');
        this.ctx.font = font
          ? `${font.style || 'normal'} ${font.weight || 400} 100px ${font.family}`
          : '100px serif';
        const widest = Math.max(...lines.map((l) => this.ctx.measureText(l).width)) || 1;

        const factor = loc.dataset.shape === 'circle' ? TCC_ENGR2_FIT_CIRCLE : TCC_ENGR2_FIT_RECT;
        const zoneW = (Number(loc.dataset.w) || 30) / 100 * TCC_ENGR2_REF * factor;
        const zoneH = (Number(loc.dataset.h) || 10) / 100 * TCC_ENGR2_REF * factor;

        const byWidth = zoneW / widest * 100;
        const byHeight = zoneH / (lines.length * TCC_ENGR2_LINE_HEIGHT);
        return Math.max(1, Math.min(byWidth, byHeight));
      }

      render(loc) {
        if (!loc || loc !== this.current) return;
        const lines = this.getLines(loc).filter(Boolean);
        const font = this.getFont(loc);

        this.zoneText.replaceChildren(...lines.map((line) => {
          const span = document.createElement('span');
          span.textContent = line;
          return span;
        }));
        this.zoneText.style.fontFamily = font ? font.family : '';
        this.zoneText.style.fontWeight = font ? font.weight : '';
        this.zoneText.style.fontStyle = font ? font.style : '';
        this.zone.style.setProperty('--zsize', this.fitSize(loc, lines, font));
      }

      loadFonts() {
        if (this._fontsLoaded || !document.fonts || !this.fonts.length) return;
        this._fontsLoaded = true;
        Promise.all(this.fonts.map((f) =>
          document.fonts.load(`${f.style || 'normal'} ${f.weight || 400} 32px ${f.family}`).catch(() => null)
        )).then(() => this.render(this.current));
      }

      /* ---------- Main product ---------- */
      getMainIdInput() {
        let el = this.parentElement;
        while (el) {
          const input = el.querySelector('form[action*="/cart/add"] [name="id"]');
          if (input) return input;
          el = el.parentElement;
        }
        return null;
      }

      getVariantId() {
        const input = this.getMainIdInput();
        return (input && input.value) || this.dataset.variantId;
      }

      getMainFormProperties() {
        const input = this.getMainIdInput();
        const form = input && (input.form || input.closest('form'));
        const props = {};
        let sellingPlan = null;
        if (!form) return { props, sellingPlan };
        new FormData(form).forEach((value, key) => {
          if (typeof value !== 'string' || value === '') return;
          if (key.startsWith('properties[')) props[key.slice(11, -1)] = value;
          if (key === 'selling_plan') sellingPlan = value;
        });
        return { props, sellingPlan };
      }

      /* ---------- Open / close ---------- */
      open() {
        if (!this.isConnected || this.dialog.open) return;
        this.setFormError('');
        this.updateTotals();
        this.current = null;
        this.setCurrent(this.locs.find((l) => this.isOpen(l)) || this.locs[0]);
        this.dialog.showModal();
        this.loadFonts();
      }

      close() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      /* ---------- Totals ---------- */
      activeAddons() {
        return this.locs.filter((l) => l.dataset.type === 'addon' && this.isOpen(l));
      }

      updateTotals() {
        const variant = this.variants[this.getVariantId()];
        const base = variant ? variant.price : 0;
        const addons = this.activeAddons().reduce((sum, l) => sum + (parseInt(l.dataset.price, 10) || 0), 0);
        const total = this.formatMoney(base + addons);
        this.querySelector('[data-engr2-subtotal]').textContent = total;
        this.querySelector('[data-engr2-total-price]').textContent = total;
        this.submitBtn.disabled = Boolean(variant && !variant.available);
      }

      formatMoney(cents) {
        const format = String(this.moneyFormat || TCC_ENGR2_MONEY_FALLBACK).replace(/<[^>]*>/g, '');
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const name = match ? match[1] : 'amount';
        const fmt = (decimals, thousands, decimal) => {
          const [int, frac] = (cents / 100).toFixed(decimals).split('.');
          const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return frac ? grouped + decimal + frac : grouped;
        };
        let value;
        switch (name) {
          case 'amount_no_decimals': value = fmt(0, ',', '.'); break;
          case 'amount_with_comma_separator': value = fmt(2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
          case 'amount_with_apostrophe_separator': value = fmt(2, "'", '.'); break;
          case 'amount_with_space_separator': value = fmt(2, ' ', ','); break;
          default: value = fmt(2, ',', '.');
        }
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      }

      /* ---------- Errors ---------- */
      setLocError(loc, message) {
        const error = loc.querySelector('[data-engr2-error]');
        if (error) { error.textContent = message; error.hidden = !message; }
        this.getLineInputs(loc).forEach((i) => i.setAttribute('aria-invalid', message ? 'true' : 'false'));
      }

      setFormError(message) {
        this.formError.textContent = message;
        this.formError.hidden = !message;
      }

      /* ---------- Cart ---------- */
      /* Value for the "Linked Product" property on the Extra Engrave line */
      getLinkedValue() {
        switch (this.dataset.linkedValue) {
          case 'product_id': return String(this.dataset.productId || '');
          case 'handle': return this.dataset.productHandle || '';
          case 'title': return this.dataset.productTitle || '';
          default: return String(this.getVariantId() || '');
        }
      }

      propName(pattern, loc) {
        return pattern.replace(/\[location\]/g, loc.dataset.name || '').trim();
      }

      buildItems() {
        const requiredMsg = this.dataset.errorRequired || 'Please enter your engraving.';
        const fontPattern = this.dataset.fontProp || '[location] Font';
        const title = this.dataset.productTitle;
        let firstInvalid = null;

        const { props: mainProps, sellingPlan } = this.getMainFormProperties();
        const addonItems = [];

        this.locs.filter((l) => this.isOpen(l)).forEach((loc) => {
          const text = this.getText(loc);
          const isMain = loc.dataset.type === 'main';

          if (!text) {
            if (!isMain || loc.dataset.required === 'true') {
              this.setLocError(loc, requiredMsg);
              firstInvalid = firstInvalid || loc;
            }
            return;
          }

          const font = this.getFont(loc);
          const props = {};
          props[loc.dataset.property] = text;
          if (font) props[this.propName(fontPattern, loc)] = font.name;

          if (isMain) {
            Object.assign(mainProps, props);
          } else {
            const addonProps = Object.assign({ _customization_item: 'true' }, props, { 'Belongs To': title });
            const linkedProp = (this.dataset.linkedProp || '').trim();
            if (linkedProp) addonProps[linkedProp] = this.getLinkedValue();
            addonItems.push({
              id: Number(loc.dataset.variantId),
              quantity: 1,
              properties: addonProps
            });
          }
        });

        if (firstInvalid) {
          this.setCurrent(firstInvalid);
          const input = this.getLineInputs(firstInvalid)[0];
          if (input) input.focus();
          return null;
        }

        const mainItem = { id: Number(this.getVariantId()), quantity: 1 };
        if (Object.keys(mainProps).length) mainItem.properties = mainProps;
        if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);
        return [mainItem, ...addonItems];
      }

      async submit() {
        if (this.submitBtn.disabled) return;
        this.setFormError('');
        const items = this.buildItems();
        if (!items) return;

        this.submitBtn.disabled = true;
        this.submitBtn.classList.add('is-loading');
        this.submitBtn.setAttribute('aria-busy', 'true');

        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');

          this.close();
          this.reset();
          document.dispatchEvent(new CustomEvent('tcc:engraving:added', { detail: { items, response: data } }));
          document.dispatchEvent(new Event(this.dataset.cartEvent || 'gOpenCart'));
        } catch (err) {
          this.setFormError(err.message);
        } finally {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.removeAttribute('aria-busy');
          this.updateTotals();
        }
      }

      reset() {
        this.locs.forEach((loc) => {
          this.getLineInputs(loc).forEach((input) => { input.value = ''; });
          this.refreshCounts(loc);
          const firstFont = loc.querySelector('[data-engr2-font]');
          if (firstFont) firstFont.checked = true;
          const toggle = loc.querySelector('[data-engr2-toggle]');
          if (toggle && toggle.checked) { toggle.checked = false; this.onToggle(loc, toggle); }
          this.setLocError(loc, '');
        });
        this.current = null;
      }
    }

    customElements.define('tcc-engraving-v2', TccEngravingV2);
  }
  } catch(e) { console.error(e); }
})();

})();
